
let callSignIn = require("./passwordless.login.js");
let callRegister = require("./passwordless.register.js");
export class ISiteMobilePasswordlessAuthIndexPage
{
    public Init() {
        $("#btnSignIn").click(() => callSignIn(event));
        $("#btnRegister").click(() => callRegister(event));  

    }
}
